import React, { createContext, useContext } from 'react';
import formatOnlyTime from './formatOnlyTime';
import formatElapsedTime from './formatElapsedTime';
import formatExpiryDate from './formatExpiryDate';
const t = (a) => a;
const formatDate = (date) => String(date);
export const defaults = { t, formatDate, formatOnlyTime, formatElapsedTime, formatExpiryDate };
export const LocalizationContext = createContext(defaults);
export const LocalizationProvider = ({ localization, children }) => (React.createElement(LocalizationContext.Provider, { value: localization }, children));
//  use only with legacy components (classes) which don't support hooks
export const withLocalization = (Component) => React.forwardRef((props, ref) => (React.createElement(LocalizationContext.Consumer, null, (localization) => React.createElement(Component, { ...props, localization: localization, ref: ref }))));
const useLocalization = () => useContext(LocalizationContext);
export default useLocalization;
//# sourceMappingURL=index.js.map